module.exports = __webpack_public_path__ + "media/images/lp_consultation/reviews-voice01-2b826061db7805c50b6c83f846a5467b.jpg";